(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mutescene-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ms-location-panel-v2')) {
    customElements.define('ms-location-panel-v2', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('.ms-location-trigger');
        if (!dialog || !trigger) return;
        const pickers = [...this.querySelectorAll('.ms-location-picker')];
        const syncSelections = () => pickers.forEach(picker => {
          const selected = picker.querySelector('input:checked');
          if (selected) picker.querySelector('[data-current-selection]').textContent = selected.closest('label').querySelector('span').textContent;
        });
        pickers.forEach(picker => {
          picker.addEventListener('toggle', () => {
            if (picker.open) pickers.forEach(other => { if (other !== picker) other.open = false; });
          }, options);
          picker.addEventListener('change', () => {
            syncSelections();
            picker.open = false;
            picker.querySelector('summary').focus();
          }, options);
        });
        trigger.addEventListener('click', () => {
          dialog.querySelector('form').reset();
          pickers.forEach(picker => { picker.open = false; });
          syncSelections();
          this.previousOverflow = document.documentElement.style.overflow;
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        }, options);
        this.querySelector('[data-location-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          trigger.focus();
        }, options);
      }
      disconnectedCallback() {
        if (this.querySelector('dialog')?.open) document.documentElement.style.overflow = this.previousOverflow || '';
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mutescene-media-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ms-media-hero')) {
    customElements.define('ms-media-hero', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches || this.dataset.autoplay !== 'true';
        this.hovered = false;
        this.focused = false;
        this.inView = true;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i), options));
        this.querySelector('[data-pause]')?.addEventListener('click', () => { this.paused = !this.paused; this.syncButton(); this.schedule(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
        this.addEventListener('keydown', event => {
          if (event.target.tagName === 'VIDEO') return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
        }, options);
        this.addEventListener('touchstart', event => { this.touch = [event.touches[0].clientX, event.touches[0].clientY]; }, { ...options, passive: true });
        this.addEventListener('touchend', event => {
          if (!this.touch || event.target.closest('video,button')) return;
          const dx = event.changedTouches[0].clientX - this.touch[0];
          const dy = event.changedTouches[0].clientY - this.touch[1];
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
          this.touch = null;
        }, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => { const i = this.slides.indexOf(event.target.closest('[data-slide]')); if (i >= 0) { this.paused = true; this.syncButton(); this.show(i); } }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.slides.forEach(slide => {
          const video = slide.querySelector('video');
          video?.addEventListener('ended', () => { if (this.canRun() && slide === this.slides[this.index]) this.show(this.index + 1); }, options);
          video?.addEventListener('error', () => { if (slide === this.slides[this.index] && this.canRun()) this.timer = setTimeout(() => this.show(this.index + 1), 5000); }, options);
        });
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, { threshold: .15 });
        this.observer.observe(this);
        this.syncButton();
        this.show(0);
      }
      canRun() { return !this.paused && !this.hovered && !this.focused && this.inView && !document.hidden; }
      syncButton() { const b = this.querySelector('[data-pause]'); if (b) { b.textContent = this.paused ? '▶' : '❚❚'; b.setAttribute('aria-label', this.paused ? b.dataset.playLabel : b.dataset.pauseLabel); b.setAttribute('aria-pressed', String(this.paused)); } }
      show(index) {
        if (!this.slides.length) return;
        clearTimeout(this.timer);
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          const v = slide.querySelector('video');
          if (v && !active) { v.pause(); v.currentTime = 0; }
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        const video = this.slides[this.index]?.querySelector('video');
        if (!this.canRun()) { video?.pause(); return; }
        if (video) {
          video.muted = true;
          if (video.ended) video.currentTime = 0;
          video.play().catch(() => {});
        } else if (this.slides.length > 1) {
          this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.delay) || 6000);
        }
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); this.querySelectorAll('video').forEach(video => video.pause()); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
